import { Pencil, Trash2 } from "lucide-react";
import type { Transaction } from "../types";
import { formatCurrency } from "../utils/currency";

interface TransactionListProps {
  transactions: Transaction[];
  onEdit: (transaction: Transaction) => void;
  onDelete: (transaction: Transaction) => void;
  deletingId?: string;
}

export function TransactionList({ transactions, onEdit, onDelete, deletingId }: TransactionListProps) {
  if (transactions.length === 0) {
    return (
      <div className="empty-transactions">
        <div className="empty-icon">¥</div>
        <h2>这一天还没有账目</h2>
        <p>添加第一笔记录，日历会自动汇总支出。</p>
      </div>
    );
  }

  return (
    <div className="transaction-list">
      {transactions.map((item) => (
        <article className="transaction-item" key={item.id}>
          <div className={`category-dot ${item.type}`} aria-hidden="true">{item.category.slice(0, 1)}</div>
          <div className="transaction-main">
            <div className="transaction-title-row">
              <h3>{item.note || item.category}</h3>
              <strong className={item.type}>
                {item.type === "expense" ? "−" : "+"}{formatCurrency(item.amount_cents)}
              </strong>
            </div>
            <p><span>{item.category}</span><time>{item.transaction_time}</time></p>
          </div>
          <div className="transaction-actions">
            <button className="icon-button" onClick={() => onEdit(item)} aria-label={`编辑${item.note || item.category}`}><Pencil size={17} /></button>
            <button className="icon-button danger" disabled={deletingId === item.id} onClick={() => onDelete(item)} aria-label={`删除${item.note || item.category}`}><Trash2 size={17} /></button>
          </div>
        </article>
      ))}
    </div>
  );
}
